export const IMAGES = 'images';
export const MOTIONS = 'motions';
export const IMAGE = 'image';
export const VIDEO = 'video/mp4';
